(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lus-cart-installation-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luscentra-installation-request')) {
    const saveState = { revision: 0, intent: null, failed: false };
    const requests = () => [...document.querySelectorAll('luscentra-installation-request')];
    const cartChangeBlocked = () => {
      const state = window.luscentraCartChangeState;
      return Boolean(state && (state.pending || state.reconciling || state.failed || state.needsReconcile));
    };
    const refreshCheckoutGuard = () => {
      const blocked = cartChangeBlocked() || Boolean(window.luscentraInstallationRequestUpdate) || saveState.failed ||
        requests().some((request) => !request.hidden && request.dataset.checkoutBlocked === 'true');
      document.documentElement.classList.toggle('lus-installation-consent-pending', blocked);
    };

    class LuscentraInstallationRequest extends HTMLElement {
      connectedCallback() {
        const hasStarterKit = this.dataset.hasStarterKit === 'true';
        this.requestCheckbox = this.querySelector('[data-installation-request-checkbox]');
        this.consentCheckbox = this.querySelector('[data-installation-consent-checkbox]');
        this.consentPanel = this.querySelector('[data-installation-consent-panel]');
        this.status = this.querySelector('[data-installation-request-status]');
        this.retryButton = this.querySelector('[data-installation-request-retry]');
        this.retryButton?.addEventListener('click', () => {
          const cartState = window.luscentraCartChangeState;
          if (cartState?.failed && !cartState.pending && !cartState.reconciling) {
            cartState.retry?.();
            return;
          }
          if (!window.luscentraInstallationRequestUpdate && saveState.failed && saveState.intent) {
            this.persistRequest(saveState.intent.requested, saveState.intent.options).catch(() => {});
          }
        });
        if (!hasStarterKit) {
          this.hidden = true;
          if (this.dataset.hasInstallationAttributes === 'true' || this.dataset.consented === 'true' ||
              this.dataset.selected === 'true' || this.dataset.storedModels || this.dataset.storedItems ||
              (saveState.intent && (window.luscentraInstallationRequestUpdate || saveState.failed) &&
                (saveState.intent.requested || saveState.intent.options.requestedUi || saveState.intent.options.declined))) {
            this.persistRequest(false, {
              requestedUi: false,
              consentedUi: false,
              declined: false
            }).catch(() => {});
          } else if (cartChangeBlocked() || window.luscentraInstallationRequestUpdate || saveState.failed) {
            this.renderSaveState();
          }
          return;
        }
        if (!this.requestCheckbox || !this.consentCheckbox) {
          this.hidden = true;
          return;
        }
        this.requestCheckbox?.addEventListener('change', (event) => {
          event.stopPropagation();
          this.updateRequestChoice();
        });
        this.consentCheckbox?.addEventListener('change', (event) => {
          event.stopPropagation();
          this.updateConsentChoice();
        });

        if (saveState.intent && (window.luscentraInstallationRequestUpdate || saveState.failed)) {
          const intent = saveState.intent;
          this.syncConsentState(intent.options.requestedUi, intent.options.consentedUi);
          if (intent.requested && (this.dataset.models !== intent.models || this.dataset.items !== intent.items)) {
            this.persistRequest(intent.requested, intent.options).catch(() => {});
          } else {
            this.renderSaveState();
          }
          return;
        }

        const selected = this.dataset.selected === 'true';
        const consented = this.dataset.consented === 'true';
        const modelsChanged = this.dataset.models !== this.dataset.storedModels;
        const itemsChanged = this.dataset.items !== this.dataset.storedItems;

        this.syncConsentState(selected, consented);
        if (selected && consented && (!hasStarterKit || modelsChanged || itemsChanged)) {
          this.persistRequest(hasStarterKit && consented).catch(() => {});
        }
      }

      syncConsentState(requested, consented) {
        this.requestCheckbox.checked = requested;
        this.consentCheckbox.checked = requested && consented;
        this.consentCheckbox.required = requested;
        this.consentCheckbox.setAttribute('aria-required', String(requested));
        this.consentPanel.hidden = !requested;
        this.toggleCheckoutGuard(requested && !consented);
      }

      toggleCheckoutGuard(blocked) {
        this.dataset.checkoutBlocked = String(blocked);
        refreshCheckoutGuard();
      }

      async updateRequestChoice() {
        if (this.isConnected === false || cartChangeBlocked()) { this.renderSaveState(); return; }
        const requested = this.requestCheckbox.checked;
        this.status.textContent = '';

        if (requested) {
          if (window.luscentraInstallationRequestUpdate || saveState.failed || this.dataset.selected === 'true') {
            await this.persistRequest(false, {
              requestedUi: true, consentedUi: false, declined: false
            }).catch(() => {});
            return;
          }
          this.syncAcrossInstances(true, false, false);
          this.status.textContent = this.dataset.pendingMessage;
          this.consentCheckbox.focus();
          return;
        }

        await this.persistRequest(false, {
          requestedUi: false, consentedUi: false, declined: true
        }).catch(() => {});
      }

      async updateConsentChoice() {
        if (this.isConnected === false || cartChangeBlocked()) { this.renderSaveState(); return; }
        const consented = this.consentCheckbox.checked;
        const requested = this.requestCheckbox.checked;
        if (!requested) return;
        await this.persistRequest(consented, consented ? undefined : {
          requestedUi: true, consentedUi: false, declined: false
        }).catch(() => {});
      }

      async persistRequest(requested, options = {}) {
        if (this.isConnected === false) return;
        if (requested && this.dataset.hasStarterKit !== 'true') {
          requested = false;
          options = { requestedUi: false, consentedUi: false, declined: false };
        }
        const requestedUi = options.requestedUi ?? requested;
        const consentedUi = options.consentedUi ?? requested;
        const declined = options.declined ?? false;
        const revision = ++saveState.revision;
        const previous = window.luscentraInstallationRequestUpdate;
        saveState.failed = false;
        saveState.intent = {
          requested, options: { requestedUi, consentedUi, declined },
          models: this.dataset.models, items: this.dataset.items
        };
        const source = this;
        const root = window.Shopify?.routes?.root || '/';
        const consentedAt = new Date().toISOString();
        const attributes = {
          'Free installation requested': requested ? 'Yes' : '',
          'Installation kit models': requested ? source.dataset.models : '',
          'Installation kit items': requested ? source.dataset.items : '',
          'Installation request declined': requested ? '' : (declined ? 'Yes' : ''),
          'Installation WhatsApp consent': requested ? 'Yes' : '',
          'Installation WhatsApp service consent': requested ? 'Yes' : '',
          'Installation WhatsApp marketing consent': requested ? 'Yes' : '',
          'Installation consent captured at': requested ? consentedAt : '',
          'Installation consent source': requested ? 'complimentary installation request' : '',
          'Installation consent form version': requested ? 'cart-installation-v3' : '',
          'Installation consent disclosure': requested ? 'installation-whatsapp-service-marketing-v3' : '',
          'Installation consent type': requested ? 'whatsapp_transactional_and_marketing' : '',
          'Installation consent cart token': requested ? source.dataset.cartToken : ''
        };

        // Serialize writes; an older response must never overwrite or unlock the latest choice.
        const update = Promise.resolve(previous).catch(() => {}).then(() => {
          if (revision !== saveState.revision) return;
          return fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ attributes })
          }).then((response) => {
            if (!response.ok) throw new Error('Cart update failed');
            return response.json();
          });
        }).then(() => {
          if (revision !== saveState.revision) return;
          window.luscentraInstallationRequestUpdate = null;
          this.syncAcrossInstances(requestedUi, consentedUi, requested);
          requests().forEach((request) => {
            request.dataset.hasInstallationAttributes = String(requested || declined);
            if (request.dataset.hasStarterKit === 'false') request.hidden = true;
          });
          this.renderSaveState(requested ? this.dataset.selectedMessage :
            (requestedUi ? this.dataset.requiredMessage : this.dataset.clearedMessage));
        }).catch((error) => {
          if (revision === saveState.revision) {
            window.luscentraInstallationRequestUpdate = null;
            saveState.failed = true;
            this.renderSaveState();
          }
          throw error;
        });
        window.luscentraInstallationRequestUpdate = update;
        this.syncAcrossInstances(requestedUi, consentedUi, false);
        this.renderSaveState();
        return update;
      }

      renderSaveState(message) {
        const cartState = window.luscentraCartChangeState;
        const cartFailed = Boolean(cartState?.failed && !cartState.pending && !cartState.reconciling);
        const pending = Boolean(cartState?.pending || cartState?.reconciling || window.luscentraInstallationRequestUpdate);
        requests().forEach((request) => {
          if (request.requestCheckbox) request.requestCheckbox.disabled = cartChangeBlocked();
          if (request.consentCheckbox) request.consentCheckbox.disabled = cartChangeBlocked();
          if (pending) request.setAttribute?.('aria-busy', 'true');
          else request.removeAttribute?.('aria-busy');
          if (request.retryButton) request.retryButton.hidden = !(cartFailed || saveState.failed);
          if (cartChangeBlocked() || saveState.failed) request.hidden = false;
          else if (!pending && request.dataset.hasStarterKit === 'false') request.hidden = true;
          if (request.status) request.status.textContent = cartFailed ?
            'We could not confirm your cart. Please retry before checkout.' :
            (saveState.failed ? request.dataset.errorMessage :
            (pending ? (cartChangeBlocked() ? 'Updating your cart. Please wait before checkout.' : request.dataset.savingMessage) : (message || '')));
        });
        refreshCheckoutGuard();
      }

      syncAcrossInstances(requested, consented, persisted) {
        document.querySelectorAll('luscentra-installation-request').forEach((request) => {
          if (request.dataset.hasStarterKit === 'false') {
            request.dataset.selected = 'false';
            request.dataset.consented = 'false';
            request.dataset.storedModels = '';
            request.dataset.storedItems = '';
            request.dataset.checkoutBlocked = 'false';
            return;
          }
          request.dataset.selected = String(persisted);
          request.dataset.consented = String(consented);
          request.dataset.storedModels = persisted ? (saveState.intent?.models ?? request.dataset.models) : '';
          request.dataset.storedItems = persisted ? (saveState.intent?.items ?? request.dataset.items) : '';
          if (request.requestCheckbox && request.consentCheckbox) {
            request.syncConsentState(requested, consented);
          } else {
            request.dataset.checkoutBlocked = 'false';
          }
        });
        refreshCheckoutGuard();
      }
    }

    customElements.define('luscentra-installation-request', LuscentraInstallationRequest);

    document.addEventListener('luscentra:cart-change-state', () => {
      requests()[0]?.renderSaveState();
      refreshCheckoutGuard();
    });

    const guardCheckout = (event) => {
      const blockedRequest = requests()
        .find((request) => !request.hidden && request.requestCheckbox?.checked && !request.consentCheckbox?.checked);
      if (!blockedRequest && !cartChangeBlocked() && !window.luscentraInstallationRequestUpdate && !saveState.failed) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const request = blockedRequest || requests()[0];
      if (!request) return;
      if (cartChangeBlocked() || window.luscentraInstallationRequestUpdate || saveState.failed) {
        request.renderSaveState();
        if (saveState.failed || window.luscentraCartChangeState?.failed) request.retryButton?.focus();
      } else {
        request.status.textContent = request.dataset.requiredMessage;
        request.consentCheckbox.focus();
      }
      if (!request.hidden) request.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    document.addEventListener('click', (event) => {
      if (event.target.closest('[name="checkout"]')) guardCheckout(event);
    }, true);
    document.addEventListener('submit', (event) => {
      const implicitCheckout = !event.submitter &&
        ['cart', 'CartDrawer-Form'].includes(event.target?.id);
      if (implicitCheckout || event.submitter?.matches('[name="checkout"]')) guardCheckout(event);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lus-cookie-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.querySelector('[data-lus-cookie-notice]');
    if (!notice) return;

    const storageKey = 'luscentra_cookie_notice_seen_v2';
    const cookieName = 'luscentra_cookie_notice_seen';
    const dismissButton = notice.querySelector('[data-lus-cookie-dismiss]');
    let dismissed = false;
    let lastObservedScrollY = window.scrollY;
    let userScrollDistance = 0;
    let userScrollIntentUntil = 0;
    let lastTouchY = null;

    const cookieWasSet = () => document.cookie
      .split('; ')
      .some((part) => part.startsWith(`${cookieName}=`));

    const hasBeenSeen = () => {
      try {
        return window.localStorage.getItem(storageKey) === '1';
      } catch (error) {
        return cookieWasSet();
      }
    };

    const markAsSeen = () => {
      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (error) {
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `${cookieName}=1; Max-Age=31536000; Path=/; SameSite=Lax${secure}`;
      }
    };

    const syncBottomOffset = () => {
      const selectors = [
        '.lus-pdp__sticky[data-lus-ready]:not([hidden])',
        '.lus-home-sticky-shop:not([hidden])',
        '.lus-wq__sticky:not([hidden])'
      ];
      let offset = window.matchMedia('(max-width: 749px)').matches ? 12 : 16;

      selectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (!element) return;
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        if (style.visibility === 'hidden' || Number(style.opacity) === 0 || rect.height === 0) return;
        if (rect.bottom >= window.innerHeight - 2) {
          offset = Math.max(offset, Math.ceil(window.innerHeight - rect.top + 12));
        }
      });

      notice.style.setProperty('--lus-cookie-bottom', `${offset}px`);
    };

    const dismiss = () => {
      if (dismissed) return;
      dismissed = true;
      markAsSeen();
      notice.classList.remove('is-visible');
      notice.classList.add('is-leaving');
      document.body.classList.remove('lus-cookie-notice-open');
      window.setTimeout(() => {
        notice.hidden = true;
      }, 300);
    };

    if (hasBeenSeen()) return;

    markAsSeen();
    syncBottomOffset();
    notice.hidden = false;
    document.body.classList.add('lus-cookie-notice-open');
    window.requestAnimationFrame(() => notice.classList.add('is-visible'));

    dismissButton?.addEventListener('click', dismiss);
    window.addEventListener('resize', syncBottomOffset, { passive: true });
    window.setTimeout(syncBottomOffset, 400);

    const noteUserScrollIntent = () => {
      userScrollIntentUntil = window.performance.now() + 900;
    };

    window.addEventListener('wheel', (event) => {
      if (event.deltaY > 0 && Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
        noteUserScrollIntent();
      }
    }, { passive: true });

    window.addEventListener('touchstart', (event) => {
      lastTouchY = event.touches[0]?.clientY ?? null;
    }, { passive: true });

    window.addEventListener('touchmove', (event) => {
      const currentTouchY = event.touches[0]?.clientY;
      if (lastTouchY !== null && currentTouchY !== undefined && currentTouchY < lastTouchY - 4) {
        noteUserScrollIntent();
      }
      lastTouchY = currentTouchY ?? null;
    }, { passive: true });

    window.addEventListener('touchend', () => {
      lastTouchY = null;
    }, { passive: true });

    window.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (!['ArrowDown', 'PageDown', ' ', 'End'].includes(event.key)) return;

      const activeElement = document.activeElement;
      if (activeElement?.matches('input, textarea, select, button, a, [contenteditable="true"]')) return;
      noteUserScrollIntent();
    });

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const scrollDelta = currentScrollY - lastObservedScrollY;
      lastObservedScrollY = currentScrollY;

      if (window.performance.now() > userScrollIntentUntil || scrollDelta <= 0) return;

      userScrollDistance += scrollDelta;
      const threshold = Math.max(120, Math.min(180, window.innerHeight * 0.14));
      if (userScrollDistance >= threshold) dismiss();
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
